<template>
  <div class="centered-container">
    <md-content class="md-elevation-3">
      <div class="title">
        <img src="@/assets/img/logo.svg" />
        <div class="md-body-1" data-testid="login-title">
          P.S. Cooperation Dashboard <strong>BETA</strong>
        </div>
      </div>

      <div class="form">
        <md-field>
          <label data-testid="login-labelemail">E-mail</label>
          <md-input
            v-model="login.email"
            autofocus
            data-testid="login-mail"
          ></md-input>
        </md-field>

        <md-field md-has-password>
          <label data-testid="login-labelpassword">Password</label>
          <md-input
            v-model="login.password"
            type="password"
            data-testid="login-password"
            v-on:keyup.enter="auth"
          ></md-input>
        </md-field>
      </div>

      <div class="actions md-layout md-alignment-center-space-between">
        <md-button
          class="md-raised login-button"
          @click="auth"
          data-testid="login-button"
          >Log in</md-button
        >
      </div>

      <div class="loading-overlay" v-if="loading">
        <md-progress-spinner
          md-mode="indeterminate"
          :md-stroke="2"
        ></md-progress-spinner>
      </div>
    </md-content>
    <div class="background"></div>
  </div>
</template>

<script>
import api from "@/api/api";
import store from "@/store/index.js";

export default {
  name: "App",
  data() {
    return {
      loading: false,
      login: {
        email: "",
        password: "",
      },
      showDialog: false,
    };
  },
  methods: {
    auth() {
      this.loading = true;
      api
        .sendAuth(this.login.email, this.login.password)
        .then((response) => {
          if (response.status !== 200) {
            alert("Authentication failed: " + response.data.error);
            this.loading = false;
          } else {
            store.commit("setAuth", response.headers["x-auth-header"]);
            store.commit("setEmail", this.login.email);
            localStorage.setItem("auth", response.headers["x-auth-header"]);
            localStorage.setItem("email", this.login.email);
            localStorage.setItem("user", JSON.stringify(response.data));
            localStorage.setItem("alerted", "no");
            this.$router.push({ name: "Dashboard" });
          }
        })
        .catch((error) => {
          alert("Authentication failed: " + error);
          this.loading = false;
        });
    },
    resetPassword() {
      this.$notify({
        message: this.$t("reset_password_notification"),
        icon: "info",
        horizontalAlign: "center",
        verticalAlign: "top",
        type: "warning",
      });
    },
  },
};
</script>

<style lang="scss">
.centered-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 100vh;
  .title {
    text-align: center;
    margin-bottom: 30px;
    img {
      margin-bottom: 16px;
      max-width: 200px;
    }
  }
  .form {
    margin-bottom: 60px;
  }
  .background {
    background-image: url("../assets/img/landing_page_background.jpg");
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 0;
  }
  .md-content {
    z-index: 1;
    padding: 40px;
    width: 100%;
    max-width: 400px;
    position: relative;
  }
  .loading-overlay {
    z-index: 10;
    top: 0;
    left: 0;
    right: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .login-button {
    margin-left: auto; margin-right: 0;
    background-color: #80214a !important;
  }
  .md-dialog .md-dialog-container {
    max-width: 768px;
  }
}
</style>
